/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type GetDocumentsFormatOrderItem = typeof GetDocumentsFormatOrderItem[keyof typeof GetDocumentsFormatOrderItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDocumentsFormatOrderItem = {
  relevance: 'relevance',
  newest: 'newest',
  oldest: 'oldest',
  executive_order_number: 'executive_order_number',
} as const;
